import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset window scroll
    window.scrollTo(0, 0);

    // Reset document element scroll
    document.documentElement.scrollTop = 0;
    
    // Reset body scroll
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
